import _ from 'lodash';
import { getColor } from 'common/constants/_colors';
import { Flex } from 'components/base/layout-components';
import PieChart from 'components/PieChart';
import StackedAreaChart from 'components/StackedAreaChart';
import { getPieItem, PROJECTS } from '../services/projects.services';
import InvestmentBreakdownLegend from './InvestmentBreakdownLegend';
import { PROJECTS_VIEW_TYPES } from '../projects.consts';
import { Box } from '@mui/material';

const InvestmentBreakdown = ({
  displayType,
  investmentSummary = [],
  investmentColorsMap
}) => {
  const stackedChartData = {
    chart: {
      type: 'column',
      backgroundColor: null,
      margin: PROJECTS.LARGE_CHART_MARGIN
    },
    xAxis: {
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      minorTickLength: 0,
      tickLength: 0,
      lineWidth: 1,
      labels: {
        enabled: false
      }
    },
    yAxis: [
      {
        tickInterval: 10,
        lineWidth: 0,
        gridLineWidth: 0,
        title: {
          enabled: false
        },
        labels: {
          enabled: true,
          style: PROJECTS.CHART_STYLE
        }
      }
    ],
    plotOptions: {
      series: {
        borderWidth: 0,
        maxPointWidth: 15
      },
      column: {
        stacking: 'percent'
      }
    },
    series: investmentSummary.map(({ category, data }) => {
      return {
        name: category,
        data,
        color: getColor(investmentColorsMap[category])
      };
    })
  };

  const investmentSummarySum = _.sum(
    investmentSummary.map(({ value }) => value)
  );

  const investmentDataSorted = _.orderBy(
    investmentSummary,
    'value',
    'desc'
  ).map(({ category, value }) => {
    return getPieItem(
      category,
      value,
      investmentSummarySum,
      investmentColorsMap
    );
  });

  switch (displayType) {
    case PROJECTS_VIEW_TYPES.EXTENDED_CHART_VIEW:
      return (
        <StackedAreaChart
          chartOptionsProp={stackedChartData}
          showLegend={false}
        />
      );
    case PROJECTS_VIEW_TYPES.EXTENDED_PIE_VIEW:
      return (
        <Flex items='flex-start'>
          <div>
            <PieChart
              data={investmentDataSorted}
              dataKey='value'
              pieSize={PROJECTS.LARGE_PIE_SIZE}
              showTooltip={false}
              noStroke={true}
            />
          </div>
          <InvestmentBreakdownLegend
            investmentDataSorted={investmentDataSorted}
            maxTopTypes={5}
          />
        </Flex>
      );
    case PROJECTS_VIEW_TYPES.ITERATION_VIEW:
      return (
        <Flex items='flex-start'>
          <div>
            <PieChart
              data={investmentDataSorted}
              dataKey='value'
              pieSize={PROJECTS.LARGE_PIE_SIZE}
              showTooltip={false}
              noStroke={true}
            />
          </div>
          <InvestmentBreakdownLegend
            investmentDataSorted={investmentDataSorted}
            isLegendHorizontal={false}
            showTitleEllipsisAfter='10rem'
          />
        </Flex>
      );
    case PROJECTS_VIEW_TYPES.PROJECTS_VIEW:
      return (
        <Flex items='center'>
          <Box sx={{ width: PROJECTS.SMALL_PIE_SIZE.width }}>
            <PieChart
              data={investmentDataSorted}
              dataKey='value'
              pieSize={PROJECTS.SMALL_PIE_SIZE}
              showTooltip={false}
              noStroke={true}
            />
          </Box>
          <InvestmentBreakdownLegend
            investmentDataSorted={investmentDataSorted}
            maxTopTypes={3}
            isLegendHorizontal={false}
          />
        </Flex>
      );
    default:
      return '';
  }
};

export default InvestmentBreakdown;
